var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wizard-base',{staticClass:"procedure-mfh",attrs:{"title":_vm.$t('WIZARD.PROCEDURE.TITLE')}},[_c('ProcedureItems',{attrs:{"items":_vm.items}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }